import React from "react";
import { authenticatedGetFetch } from "../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";

import KeyValues from "../Reports/Activity/KeyValues";
import HistoFinancial from "../Reports/Financial/HistoFinancial";
import Counters from "../Supervision/Counters";
import Gamme400 from "./Gamme400";

import { Callout } from "@blueprintjs/core";

export default class UserFavorites extends React.Component {

  constructor() {
    super();
    this.state = {
      widgets: []
    };
  }

  fetchData() {
    const UserFavs = [];
    if (localStorage.getItem('perm_home_customisation') === "true") {
      authenticatedGetFetch('/fav',
        (res) => {
          let thismorning = new Date(); // last midnight
          let now = new Date(); // now
          thismorning.setHours(0, 0, 0, 0);
          let sevendaysfromnow = new Date();
          sevendaysfromnow.setDate(sevendaysfromnow.getDate() - 30);

          for (const w of res) {
            switch (w) {
              case 0:
                UserFavs.push(<Counters key="cnt" />);
                break;

              case 1:
                UserFavs.push(<HistoFinancial
                  key="pvcb"
                  dateRange={[sevendaysfromnow.toISOString(), now.toISOString()]}
                />);
                break;

              case 2:
                UserFavs.push(
                  <KeyValues
                    key="ec"
                    params={{
                      fr: thismorning.toISOString(),
                      to: now.toISOString()
                    }}
                  />);
                break;

              case 3:
                UserFavs.push(<Gamme400 key="3" />);
                break;
              default:
                break;
            }
          }
          this.setState({ widgets: UserFavs });
        })
    }
    else {
      UserFavs.push(<Gamme400 key="3" />);
      this.setState({ widgets: UserFavs });
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  render() {
    if (this.state.widgets !== undefined && this.state.widgets.length > 0)
      return (<div>{this.state.widgets}</div>);
    else
      return (<Callout intent="info"><Trans>you can customize your home page in the setting page</Trans></Callout>);
  }
}